import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import {InlineMarkdownEditor} from '../../elements/InlineMarkdownEditor';
import {REPORT_FONT_SIZE} from '../constants';
import * as HeadingStyles from './headings.styles';

export const MarkdownBlockWrapper = styled.div`
  ${HeadingStyles.HeadingCollapser}, ${HeadingStyles.DeepLink} {
    padding-top: ${REPORT_FONT_SIZE * 2}px;
  }
  ${HeadingStyles.commonHeadingStyles}
`;
export const MarkdownBlock = styled(InlineMarkdownEditor)<{
  selected?: boolean;
  focused?: boolean;
}>`
  white-space: normal;
  font-family: ${globals.fontName};
  .markdown {
    overflow: auto;
  }
  ${props =>
    !props.readOnly &&
    css`
      font-size: inherit;
      padding: 8px;
      margin: -12px 0 0 -12px;
      border-left: 4px solid transparent;
      border-radius: 4px;

      &:hover {
        background: ${globals.gray50};
      }
      textarea {
        font-family: Inconsolata;
        border: none;
        overflow: auto;
        outline: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        resize: none;
        background: none;
        padding: 2px 0;
        margin: 0;
      }
      &:not(.editing) {
        cursor: pointer;
      }

      &.editing {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left-color: ${globals.gray100};
      }
    `}
  ${props =>
    props.selected &&
    css`
      &&:not(.editing) {
        background: rgb(208, 225, 252);
      }
      .placeholder {
        opacity: 0;
      }
    `}
`;

export const EditMarkdownBlockWrapper = styled.div<{converted?: boolean}>`
  border-radius: 4px;
  background-color: rgb(34, 34, 34);
  padding: 8px 12px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  &:hover {
    color: rgba(255, 255, 255, 1);
  }
  ${props =>
    props.converted &&
    css`
      background: green;
      cursor: default;
    `}
`;
